import { useState, useEffect } from "react";
import { useApi } from "./Api";

export const useConciergeCheck = (): boolean | null => {
  const api = useApi();
  const [isConcierge, setIsConcierge] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchConcierge = async () => {
      try {
        const response = await api.get("/api/profile/IsConcierge");
        setIsConcierge(response.data === true);
      } catch (err) {
        console.error("Failed to check concierge role", err);
        setIsConcierge(false);
      }
    };

    fetchConcierge();
  }, [api]);

  return isConcierge;
};
